import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { loadCountryNameDropdownData, loadLeaveTypeDropdownData, loadUserDropdownData, postApplyLeaveDatas } from "../../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication'
import moment from "moment";

const dayTypeOptions = [
    { value: "Full Day", label: "Full Day" },
    { value: "Half Day", label: "Half Day" },
]

const sessionOptions = [
    { value: "First Half", label: "First Half" },
    { value: "Second Half", label: "Second Half" },
]

const ApplyLeavesModal = (props) => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const { getLeaveTypeDropdown } = useSelector((state) => state.data);
    const { getUserDropdown } = useSelector((state) => state.data);
    const { getCountryNameDropdown } = useSelector((state) => state.data);

    useEffect(() => {
        dispatch(loadUserDropdownData());
        dispatch(loadLeaveTypeDropdownData());
    }, [])

    // ✅ State for form fields
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedLeaveType, setSelectedLeaveType] = useState(null);
    const [selectedReportingTo, setSelectedReportingTo] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [leaveDuration, setLeaveDuration] = useState("");
    const [selectedDayType, setSelectedDayType] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);
    const [reason, setReason] = useState("");
    const [error, setError] = useState('');
    const [validationError, setValidationError] = useState('');
    const [filteredLeaveTypes, setFilteredLeaveTypes] = useState([]);

    useEffect(() => {
        if (startDate && endDate) {
            const duration = moment(endDate).diff(moment(startDate), 'days') + 1;
            setLeaveDuration(selectedDayType?.value === "Half Day" ? 0.5 : duration);
        }
    }, [startDate, endDate, selectedDayType]);

    useEffect(() => {
        dispatch(loadCountryNameDropdownData());
    }, [])

    useEffect(() => {
        if (startDate && endDate) {
            const duration = moment(endDate).diff(moment(startDate), 'days') + 1;

            if (moment(startDate).format("DD/MM/YYYY") !== moment(endDate).format("DD/MM/YYYY")) {
                // If it's more than one day, automatically set Full Day
                setSelectedDayType({ value: "Full Day", label: "Full Day" });
            } else {
                // Reset day type selection for single-day leave
                setSelectedDayType(null);
            }

            setLeaveDuration(selectedDayType?.value === "Half Day" ? 0.5 : duration);
        }
    }, [startDate, endDate]);

    // const handleUserChange = (selectedOption) => {
    //     setSelectedUser(selectedOption);
    //     setError((prev) => ({ ...prev, selectedUser: "" }));
    // };

    const handleUserChange = (selectedOption) => {
        setSelectedUser(selectedOption);
        setError((prev) => ({ ...prev, selectedUser: "" }));

        // ✅ Extract country code from selected user
        const countryCodeID = selectedOption?.CountryCodeID;

        if (getLeaveTypeDropdown && countryCodeID) {
            const countryObj = getCountryNameDropdown.find(country => country.CountryCodeID === countryCodeID);
            const countryName = countryObj ? countryObj.label : '';

            // ✅ Filter leave types by country name
            const policies = getLeaveTypeDropdown.filter(policy => policy.Country === countryName);
            setFilteredLeaveTypes(policies);
        } else {
            setFilteredLeaveTypes([]);
        }
    };
    console.log(getLeaveTypeDropdown,'getLeaveTypeDropdown')

    const handleLeaveTypeChange = (selectedOption) => {
        setSelectedLeaveType(selectedOption);
        setError((prev) => ({ ...prev, selectedLeaveType: "" }));
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
        setError((prev) => ({ ...prev, startDate: "" }));
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        setError((prev) => ({ ...prev, endDate: "" }));
    };

    const handleDayTypeChange = (selectedOption) => {
        setSelectedDayType(selectedOption);
        setError((prev) => ({ ...prev, selectedDayType: "" }));
    };

    const handleSessionChange = (selectedOption) => {
        setSelectedSession(selectedOption);
        setError((prev) => ({ ...prev, selectedSession: "" }));
    };

    const handleReasonChange = (e) => {
        setReason(e.target.value);
        setError((prev) => ({ ...prev, reason: "" }));
    };

    const validateForm = () => {
        let newErrors = {};
        if (!selectedUser) newErrors.selectedUser = "User is required";
        if (!selectedLeaveType) newErrors.selectedLeaveType = "Leave Type is required";
        if (!startDate) newErrors.startDate = "Start Date is required";
        if (!endDate) newErrors.endDate = "End Date is required";
        if (!leaveDuration) newErrors.leaveDuration = "Leave Duration is required";
        if (!selectedDayType) newErrors.selectedDayType = "Day Type is required";
        if (selectedDayType?.value === "Half Day" && !selectedSession) newErrors.selectedSession = "Session is required";
        if (!reason.trim()) newErrors.reason = "Reason is required";
        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✅ Submit function
    const postApplyLeaveData = (e) => {
        e.preventDefault();

        // Ensure selectedUser is set before validation
        if (!selectedUser && signInDetails[0]?.UserID) {
            setSelectedUser({ value: signInDetails[0]?.UserID, label: signInDetails[0]?.UserID });
        }

        if (!validateForm()) return;

        const data = {
            LeaveTypeID: selectedLeaveType?.value || null,
            UserID: selectedUser?.value || signInDetails[0]?.UserID || null,
            StartDate: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            EndDate: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
            LeaveDuration: leaveDuration || null,
            IsHalfDay: selectedDayType?.value === "Half Day" ? true : false,
            LeaveSession: selectedSession?.value || null,
            Reason: reason || "",
            // AppliedOn: new Date().toISOString(), // Timestamp when leave is applied
            AppliedOn: moment().format("YYYY-MM-DD"),
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postApplyLeaveDatas(requestOption, props.handleCloseModal, props.leavesData, setValidationError));
        console.log(data, 'Submitted Data');
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Apply Leaves</Modal.Title>
                </Modal.Header>
                {signInDetails[0]?.SignInType != "User" && (
                    <Modal.Body>
                        <Row className='customer-form-fields'>
                            <Col>
                                <Row>
                                    <Col md={4}>
                                        <div>
                                            <label>User  <span className="required-asterisk">*</span></label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={selectedUser}
                                                onChange={handleUserChange}
                                                options={getUserDropdown}
                                                placeholder="Select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />
                                        </div>
                                        {error.selectedUser && <div className='text-danger'>{error.selectedUser}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <div className='add-customer-calendar-container'>
                                            <label> From Date <span className="required-asterisk">*</span></label>
                                            {/* <div className='add-customer-calendar-container'> */}
                                            <DatePicker
                                                className="select from-date"
                                                id="date-range-picker"
                                                dateFormat="dd/MM/yyyy"
                                                // selectsRange
                                                placeholderText='Start Date'
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                            // maxDate={new Date()}
                                            />
                                            <img src={calendar} alt="" />
                                            {/* </div> */}
                                        </div>
                                        {error.startDate && <div className='text-danger'>{error.startDate}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <div className='add-customer-calendar-container'>
                                            <label>To Date <span className="required-asterisk">*</span></label>
                                            {/* <div className='add-customer-calendar-container'> */}
                                            <DatePicker
                                                className="select from-date"
                                                id="date-range-picker"
                                                dateFormat="dd/MM/yyyy"
                                                // selectsRange
                                                placeholderText='End Date'
                                                selected={endDate}
                                                onChange={handleEndDateChange}
                                                // maxDate={new Date()}
                                                minDate={startDate || new Date()}
                                            />
                                            <img src={calendar} alt="" />
                                            {/* </div> */}
                                        </div>
                                        {error.endDate && <div className='text-danger'>{error.endDate}</div>}
                                    </Col>
                                </Row>
                                <Row>
                                    {startDate && endDate && moment(startDate).format("DD/MM/YYYY") === moment(endDate).format("DD/MM/YYYY") && (
                                        <Col md={4}>
                                            <div>
                                                <label>Day Type <span className="required-asterisk">*</span></label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select"
                                                    options={dayTypeOptions}
                                                    value={selectedDayType}
                                                    onChange={handleDayTypeChange}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                />
                                            </div>
                                            {error.selectedDayType && <div className='text-danger'>{error.selectedDayType}</div>}
                                        </Col>)}
                                    {selectedDayType?.value === "Half Day" && (
                                        <Col md={4}>
                                            <div>
                                                <label>Session <span className="required-asterisk">*</span></label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select"
                                                    options={sessionOptions}
                                                    value={selectedSession}
                                                    onChange={handleSessionChange}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                />
                                            </div>
                                            {error.selectedSession && <div className='text-danger'>{error.selectedSession}</div>}
                                        </Col>)}
                                    <Col md={4}>
                                        <div>
                                            <label>Leave Type <span className="required-asterisk">*</span></label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={selectedLeaveType}
                                                onChange={handleLeaveTypeChange}
                                                // options={getLeaveTypeDropdown}
                                                options={filteredLeaveTypes}
                                                placeholder="Select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />
                                        </div>
                                        {error.selectedLeaveType && <div className='text-danger'>{error.selectedLeaveType}</div>}
                                    </Col>
                                </Row>
                                {/* <Row>
                                    <Col md={4}>
                                        <div>
                                            <label>Leave Type <span className="required-asterisk">*</span></label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={selectedLeaveType}
                                                onChange={handleLeaveTypeChange}
                                                options={getLeaveTypeDropdown}
                                                placeholder="Select"
                                            />
                                        </div>
                                        {error.selectedLeaveType && <div className='text-danger'>{error.selectedLeaveType}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <div>
                                            <label>Reporting To <span className="required-asterisk">*</span></label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={selectedReportingTo}
                                                onChange={setSelectedReportingTo}
                                                options={getUserDropdown}
                                                placeholder="Select"
                                            />
                                        </div>
                                    </Col>
                                </Row> */}
                                <Row>

                                    <Col md={12}>
                                        <div>
                                            <label>Reason <span className="required-asterisk">*</span></label>
                                            <Form.Control as="textarea" rows={3} value={reason} onChange={handleReasonChange} />
                                        </div>
                                        {error.reason && <div className='text-danger'>{error.reason}</div>}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body >)}
                {/* ✅ Show this modal body only if signInType is "User" */}
                {signInDetails[0]?.SignInType === "User" && (
                    <Modal.Body>
                        <Row className='customer-form-fields'>
                            <Col>
                                <Row >
                                    <Col md={12}>
                                        <div>
                                            <label>Leave Type <span className="required-asterisk">*</span></label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                placeholder="Select"
                                                options={getLeaveTypeDropdown}
                                                value={selectedLeaveType}
                                                onChange={handleLeaveTypeChange}
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />
                                        </div>
                                        {error.selectedLeaveType && <div className='text-danger'>{error.selectedLeaveType}</div>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <div className='add-customer-calendar-container'>
                                            <label>From Date <span className="required-asterisk">*</span></label>
                                            <DatePicker
                                                className="select from-date"
                                                dateFormat="dd/MM/yyyy"
                                                //  selectsRange 
                                                placeholderText='Start Date'
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                            // maxDate={new Date()}
                                            />
                                            <img src={calendar} alt="" />
                                        </div>
                                        {error.startDate && <div className='text-danger'>{error.startDate}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <div className='add-customer-calendar-container'>
                                            <label>To Date  <span className="required-asterisk">*</span></label>
                                            <DatePicker
                                                className="select from-date"
                                                dateFormat="dd/MM/yyyy"
                                                // selectsRange 
                                                selected={endDate}
                                                onChange={handleEndDateChange}
                                                placeholderText='End Date'
                                                // maxDate={new Date()}
                                                minDate={startDate || new Date()}
                                            />
                                            <img src={calendar} alt="" />
                                        </div>
                                        {error.endDate && <div className='text-danger'>{error.endDate}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <div>
                                            <label> Leave Duration <span className="required-asterisk">*</span></label>
                                            <Form.Control type="text" value={leaveDuration} onChange={(e) => setLeaveDuration(e.target.value)} disabled />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    {startDate && endDate && moment(startDate).format("DD/MM/YYYY") === moment(endDate).format("DD/MM/YYYY") && (
                                        <Col md={4}>
                                            <div>
                                                <label>Day Type <span className="required-asterisk">*</span></label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select"
                                                    options={dayTypeOptions}
                                                    value={selectedDayType}
                                                    onChange={handleDayTypeChange}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                />
                                            </div>
                                            {error.selectedDayType && <div className='text-danger'>{error.selectedDayType}</div>}
                                        </Col>)}
                                    {selectedDayType?.value === "Half Day" && (
                                        <Col md={4}>
                                            <div>
                                                <label>Session <span className="required-asterisk">*</span></label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select"
                                                    options={sessionOptions}
                                                    value={selectedSession}
                                                    onChange={handleSessionChange}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                />
                                            </div>
                                            {error.selectedSession && <div className='text-danger'>{error.selectedSession}</div>}
                                        </Col>)}
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div>
                                            <label>Reason <span className="required-asterisk">*</span></label>
                                            <Form.Control as="textarea" rows={3} value={reason} onChange={handleReasonChange} />
                                        </div>
                                        {error.reason && <div className='text-danger'>{error.reason}</div>}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                )}
                {validationError && <div className="text-danger p-2 fs-6">{validationError}</div>}
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={postApplyLeaveData} />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ApplyLeavesModal;